module.exports = __webpack_public_path__ + "static/img/13.131aaa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/13.png
// module id = iklJ
// module chunks = 0